import(/* webpackMode: "eager", webpackExports: ["CodeBlock"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/codeblock.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
